import type {MouseEventHandler, ReactNode} from 'react';
import React from 'react';

import type {ButtonTypes, IconPosition} from '../../Button';
import Button from '../../Button';
import type {IconSizes, LinkColours, LinkSizes} from '../../Link';
import Link from '../../Link';

interface ButtonOrLinkBottomLeftContentBaseProps {
  type: 'button' | 'link';
  text: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  icon?: ReactNode;
  iconUrl?: string;
  dataAutomation?: string;
  reskinClassName?: string;
}

interface BottomLeftContentButtonProps
  extends ButtonOrLinkBottomLeftContentBaseProps {
  type: 'button';
  iconPosition?: IconPosition;
  buttonType?: ButtonTypes;
}
interface BottomLeftContentLinkProps
  extends ButtonOrLinkBottomLeftContentBaseProps {
  type: 'link';
  iconSize?: IconSizes;
  linkColour?: LinkColours;
  linkSize?: LinkSizes;
}
interface BottomLeftContentElementProps {
  type: 'element';
  element: ReactNode;
}

export type BottomLeftContentProps =
  | BottomLeftContentButtonProps
  | BottomLeftContentLinkProps
  | BottomLeftContentElementProps;

const BottomLeftContent = (props: BottomLeftContentProps) => {
  if (props.type === 'element') {
    return props.element;
  }

  const {type, text, onClick, icon, iconUrl, reskinClassName, dataAutomation} =
    props;
  switch (type) {
    case 'button':
      return (
        <Button
          onClick={onClick}
          dataAutomation={dataAutomation}
          type={props.buttonType || 'thirdary'}
          icon={icon}
          iconUrl={iconUrl}
          iconPosition={props.iconPosition}
          reskinClassName={reskinClassName}
          noMarginLeft
          noMarginTop
        >
          {text}
        </Button>
      );
    case 'link':
      return (
        <Link
          onClick={onClick}
          text={text}
          icon={icon}
          iconLink={iconUrl}
          iconSize={props.iconSize}
          reskinClassName={reskinClassName}
          dataAutomation={dataAutomation}
          linkColour={props.linkColour}
          linkSize={props.linkSize}
        />
      );
    default:
      return null;
  }
};

export default BottomLeftContent;
